import { mapState } from "vuex";
import HeardLogo from "./Head-logo.vue";
import UserMessage from "./User-message.vue";
import FootLanguage from "./footLanguage.vue";
import DownloadCenter from "./download-center.vue";
import { auth } from "@/service/cas.js";
import { open } from "@/libs/common.js";
import { getServerConfigValue } from "@/service/server";
export default {
  name: "Heard",
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  components: {
    HeardLogo,
    UserMessage,
    FootLanguage,
    DownloadCenter
  },
  computed: {
    ...mapState({
      isMobile: state => state.app.isMobile
    })
  },
  methods: {
    async onOpenHelp() {
      let {
        data: {
          retVal
        }
      } = await auth(`${getServerConfigValue("VUE_APP_HELP") || "http://192.168.0.85:8080/help_new_front/#/"}?service=HELP_CENTER`);
      open(retVal, true);
    },
    collapsedSider() {
      this.$emit("collapsedSider");
    }
  }
};